<div class="notfound m-0 row justify-content-center align-items-center">
    <div class="col-auto p-5 text-center">
        <a href="http://www.freepik.com" target="_blank"><img src="../assets/img/wormsleeps.png" title="Designed by pch.vector / freepik" width="150" height="150"></a>

        <h1>Oooops! Page Not Found</h1><br>
        <p>Sorry, we couldn't find that page!</p>
        <br>
        <a type="button" class="btn btn-light" routerLink="/home">Go back to the home page</a>
    </div>
</div>